"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isShowPopup = exports.isFetchingData = exports.isAddonUpdated = exports.isActiveAddonsLoading = exports.isActiveAddonsFailed = exports.getTaxPercentage = exports.getProductOrderEndPoint = exports.getProductId = exports.getPrimaryDealerCode = exports.getPkgSlice = exports.getIsStaticAddons = exports.getEligibleAddonsApiEndpoint = exports.getDefaultAddonIcon = exports.getCustomerBalance = exports.getCurrentScreen = exports.getCurrentMode = exports.getAgentName = exports.getAddons = exports.getAddonIcons = exports.getActiveAddonsApiEndpoint = exports.eligibleAddons = exports.dateFormatSelector = exports.cancelAddon = exports.agentTokenType = exports.agentToken = exports.addonToBuy = exports.addonCancelled = exports.activeAddonsUnmapped = exports.activeAddonsMappedOptions = void 0;
var _appConstants = require("../appConstants");
var _ConfigSelectors = require("./ConfigSelectors/ConfigSelectors");
var getPkgSlice = function getPkgSlice(state) {
  return state[_appConstants.pkgName];
};
exports.getPkgSlice = getPkgSlice;
var getAddons = function getAddons(state) {
  return getPkgSlice(state).addons;
};
exports.getAddons = getAddons;
var isAddonUpdated = function isAddonUpdated(state) {
  return getPkgSlice(state).updateAddons;
};
exports.isAddonUpdated = isAddonUpdated;
var agentToken = function agentToken(state) {
  var _state$authentication;
  return (_state$authentication = state.authentication) === null || _state$authentication === void 0 || (_state$authentication = _state$authentication.agentTokenDetails) === null || _state$authentication === void 0 ? void 0 : _state$authentication.access_token;
};
exports.agentToken = agentToken;
var agentTokenType = function agentTokenType(state) {
  var _state$authentication2;
  return (_state$authentication2 = state.authentication) === null || _state$authentication2 === void 0 || (_state$authentication2 = _state$authentication2.agentTokenDetails) === null || _state$authentication2 === void 0 ? void 0 : _state$authentication2.token_type;
};
exports.agentTokenType = agentTokenType;
var isFetchingData = function isFetchingData(state) {
  return getPkgSlice(state).isFetchingData;
};
exports.isFetchingData = isFetchingData;
var getAddonIcons = function getAddonIcons(state) {
  return getPkgSlice(state).addonIconsList;
};
exports.getAddonIcons = getAddonIcons;
var getDefaultAddonIcon = function getDefaultAddonIcon(state) {
  return getPkgSlice(state).defaultAddonIcon;
};
exports.getDefaultAddonIcon = getDefaultAddonIcon;
var isShowPopup = function isShowPopup(state) {
  return getPkgSlice(state).showPopup;
};
exports.isShowPopup = isShowPopup;
var addonCancelled = function addonCancelled(state) {
  return getPkgSlice(state).cancelAddon.cancelled;
};
exports.addonCancelled = addonCancelled;
var cancelAddon = function cancelAddon(state) {
  return getPkgSlice(state).cancelAddon;
};
exports.cancelAddon = cancelAddon;
var getCurrentMode = function getCurrentMode(state) {
  return getPkgSlice(state).currentMode;
};
exports.getCurrentMode = getCurrentMode;
var addonToBuy = function addonToBuy(state) {
  return getPkgSlice(state).addonToBuy;
};
exports.addonToBuy = addonToBuy;
var eligibleAddons = function eligibleAddons(state) {
  return getPkgSlice(state).eligibleAddons;
};
exports.eligibleAddons = eligibleAddons;
var getCustomerBalance = function getCustomerBalance(state) {
  var _state$genericAction, _state$genericAction2;
  return {
    formattedBalance: (_state$genericAction = state['generic-actions']) === null || _state$genericAction === void 0 || (_state$genericAction = _state$genericAction.customerBalance) === null || _state$genericAction === void 0 ? void 0 : _state$genericAction.formattedValue,
    amount: Number((_state$genericAction2 = state['generic-actions']) === null || _state$genericAction2 === void 0 || (_state$genericAction2 = _state$genericAction2.customerBalance) === null || _state$genericAction2 === void 0 ? void 0 : _state$genericAction2.amount)
  };
};
// TODO: Remove after integration
exports.getCustomerBalance = getCustomerBalance;
var getIsStaticAddons = function getIsStaticAddons(state) {
  return getPkgSlice(state).isStaticAddons;
};
exports.getIsStaticAddons = getIsStaticAddons;
var getEligibleAddonsApiEndpoint = function getEligibleAddonsApiEndpoint(state) {
  return (0, _ConfigSelectors.propSelector)(state, 'eligibleAddonsApiEndpoint');
};
exports.getEligibleAddonsApiEndpoint = getEligibleAddonsApiEndpoint;
var getProductId = function getProductId(state) {
  var _state$props;
  return (_state$props = state.props) === null || _state$props === void 0 || (_state$props = _state$props.topupList) === null || _state$props === void 0 ? void 0 : _state$props.phoneNumber;
};
exports.getProductId = getProductId;
var getActiveAddonsApiEndpoint = function getActiveAddonsApiEndpoint(state) {
  return (0, _ConfigSelectors.propSelector)(state, 'activeAddon').apiEndpoint;
};
exports.getActiveAddonsApiEndpoint = getActiveAddonsApiEndpoint;
var activeAddonsUnmapped = function activeAddonsUnmapped(state) {
  var _getPkgSlice$activeAd;
  return (_getPkgSlice$activeAd = getPkgSlice(state).activeAddons) === null || _getPkgSlice$activeAd === void 0 || (_getPkgSlice$activeAd = _getPkgSlice$activeAd.unmappedOptions) === null || _getPkgSlice$activeAd === void 0 ? void 0 : _getPkgSlice$activeAd.payload;
};
exports.activeAddonsUnmapped = activeAddonsUnmapped;
var activeAddonsMappedOptions = function activeAddonsMappedOptions(state) {
  var _getPkgSlice$activeAd2;
  return (_getPkgSlice$activeAd2 = getPkgSlice(state).activeAddons) === null || _getPkgSlice$activeAd2 === void 0 ? void 0 : _getPkgSlice$activeAd2.mappedOptions;
};
exports.activeAddonsMappedOptions = activeAddonsMappedOptions;
var isActiveAddonsLoading = function isActiveAddonsLoading(state) {
  var _getPkgSlice$activeAd3;
  return (_getPkgSlice$activeAd3 = getPkgSlice(state).activeAddons) === null || _getPkgSlice$activeAd3 === void 0 ? void 0 : _getPkgSlice$activeAd3.isLoading;
};
exports.isActiveAddonsLoading = isActiveAddonsLoading;
var isActiveAddonsFailed = function isActiveAddonsFailed(state) {
  var _getPkgSlice$activeAd4;
  return (_getPkgSlice$activeAd4 = getPkgSlice(state).activeAddons) === null || _getPkgSlice$activeAd4 === void 0 ? void 0 : _getPkgSlice$activeAd4.error;
};
exports.isActiveAddonsFailed = isActiveAddonsFailed;
var getProductOrderEndPoint = function getProductOrderEndPoint(state) {
  return (0, _ConfigSelectors.propSelector)(state, 'productOrderEndPoint');
};
exports.getProductOrderEndPoint = getProductOrderEndPoint;
var getCurrentScreen = function getCurrentScreen(state) {
  var _getPkgSlice;
  return (_getPkgSlice = getPkgSlice(state)) === null || _getPkgSlice === void 0 ? void 0 : _getPkgSlice.currentPurchaseModalScreen;
};
exports.getCurrentScreen = getCurrentScreen;
var getPrimaryDealerCode = function getPrimaryDealerCode(state) {
  var _state$props2;
  return (_state$props2 = state.props) === null || _state$props2 === void 0 || (_state$props2 = _state$props2.storeDetails) === null || _state$props2 === void 0 ? void 0 : _state$props2.primaryDealerCode;
};
exports.getPrimaryDealerCode = getPrimaryDealerCode;
var getAgentName = function getAgentName(state) {
  var _state$authentication3;
  return (_state$authentication3 = state.authentication) === null || _state$authentication3 === void 0 || (_state$authentication3 = _state$authentication3.agentTokenDetails) === null || _state$authentication3 === void 0 || (_state$authentication3 = _state$authentication3.user_info) === null || _state$authentication3 === void 0 ? void 0 : _state$authentication3.sub;
};
exports.getAgentName = getAgentName;
var dateFormatSelector = function dateFormatSelector(state) {
  var _state$config;
  return (_state$config = state.config) === null || _state$config === void 0 || (_state$config = _state$config.data) === null || _state$config === void 0 || (_state$config = _state$config.global) === null || _state$config === void 0 ? void 0 : _state$config.dateFormat;
};
exports.dateFormatSelector = dateFormatSelector;
var getTaxPercentage = function getTaxPercentage(state) {
  var _state$config2;
  var topupConfig = state === null || state === void 0 || (_state$config2 = state.config) === null || _state$config2 === void 0 || (_state$config2 = _state$config2.data) === null || _state$config2 === void 0 || (_state$config2 = _state$config2.widgets) === null || _state$config2 === void 0 ? void 0 : _state$config2.topup;
  if (topupConfig) {
    var insID = Object.keys(topupConfig)[0];
    return topupConfig[insID].tax;
  }
  return null;
};
exports.getTaxPercentage = getTaxPercentage;